import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {invoiceverifys,invoiceverify,invoicedeliver, invoiceupload, invoiceUpdate, invoiceOrderDesc} = api

/**
 * 查找列表
 */
export async function findInvoiceverifys(params) {
    return request({url:invoiceverifys, method: 'get', data: params,})
}
/**
 * 查找详情
 */
export async function findInvoiceverify(params) {
    return request({url:invoiceverify, method: 'get', data: params,})
}
/**
 * 发票发货
 */
export async function deliverInvoice(params) {
    return request({url:invoicedeliver, method: 'post', data: params,})
}


/**
 * 发票发货
 */
export async function uploadInvoice(params) {
    return request({url:invoiceupload, method: 'post', data: params,})
}

export async function updateInvoice(params) {
    return request({url:invoiceUpdate, method: 'put', data: params,})
}

export async function findOrderDesc(params) {
    return request({url:invoiceOrderDesc, method: 'get', data: params,})
}


// WEBPACK FOOTER //
// ./src/services/invoiceVerify.js